import { Component, forwardRef, Input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ToggleSwitchChangeEvent, ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'cx-switcher',
  imports: [CommonModule, TranslateModule, FormsModule, ToggleSwitchModule],
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitcherComponent),
      multi: true,
    },
  ],
})
export class SwitcherComponent {
  @Input() label = '';
  @Input() id = '';
  @Input() checked = false;

  checkedChange = output<ToggleSwitchChangeEvent>();

  onChecked(event: ToggleSwitchChangeEvent): void {
    this.checkedChange.emit(event);
  }
}
